import { COMPANY_EXPORT_OPTIONS, CompanyExportOption } from '../constants';
import { BaseCurrentSelectedValues, BaseExcelExportDialogErrors, BaseHasData, BaseOtherOptions } from '../types';

export const EXPORT_OPTIONS = COMPANY_EXPORT_OPTIONS;
export type ExportOption = CompanyExportOption;

export interface CompanyCurrentSelectedValues extends BaseCurrentSelectedValues {
  cap_table?: number;
  fo_cap_table?: number;
  breakpoint_cap_table?: number;
  waterfall_cap_table?: number;
  financial_statement?: number;
  valuation?: number;
}

export interface CompanyExcelExportDialogErrors extends BaseExcelExportDialogErrors {
  breakpoint_cap_table?: string[];
  cap_table?: string[];
  financial_statement?: string[];
  fo_cap_table?: string[];
  valuation?: string[];
  waterfall_cap_table?: string[];
  documents?: string[];
}

export interface HasDocumentsData extends BaseHasData {
  has_documents: boolean;
}

export interface SelectedVersions {
  capTable: number | null;
  waterfallModel: number | null;
  financials: number | null;
}

export interface HasSummaryData extends BaseHasData {
  has_company_summary: boolean;
}

export interface OtherOptions extends BaseOtherOptions {
  summary: boolean;
  capTable: boolean;
  fundOwnership: boolean;
  breakpointAnalysis: boolean;
  waterfallModel: boolean;
  financials: boolean;
  valuations: boolean;
  documents: boolean;
}